<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Saved Views</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">
    <div class="alert alert-info" *ngIf="loadingSrvs">Loading...</div>

    <table *ngIf="!loadingSrvs" class="table table-hover">
      <tbody>
        <tr (click)="savedViewSelectedCallback(null);activeModal.close();">
          <td class="cursor-pointer" style="border-top: none">
            Capitan Default
          </td>
        </tr>
        <tr *ngFor="let srv of srvs" (click)="savedViewSelectedCallback(srv);activeModal.close();">
          <td class="cursor-pointer" style="line-height: 1.1">
            {{ srv.name }}
            <span class="badge badge-primary ml-2" *ngIf="personalDefaultViewId === srv.id">
              Personal Default
            </span>
            <span class="badge badge-primary ml-2" *ngIf="organizationDefaultViewId === srv.id">
              Org Default
            </span>
            <br>
            <small class="text-muted">
              Last edited by
              {{ getStaffNameDisplay(srv.last_updated_by_first_name, srv.last_updated_by_last_name, srv.last_updated_by_email) }}
              on
              {{ dateStringFromISO8601(srv.updated_at) }}
            </small>
          </td>
        </tr>
      </tbody>
    </table>

    <button class="btn btn-outline-primary mb-3" *ngIf="savedViewEdited"
            (click)="createNewSavedViewCallback();activeModal.close();">
      Create new saved view from current filters &amp; columns
    </button>

    <div class="alert alert-info" *ngIf="!savedViewEdited">
      To create a new saved view, select your desired filters and/or columns, then select "Create Saved View" or "Save as New View".
    </div>

    <div *ngIf="!loadingSrvs" class="border-top pt-3 mb-3">
      <div class="mb-2">
        <span class="d-inline-block"
              [ngbTooltip]="apiService.inPinMode ?
                'Your default view cannot be changed in PIN mode.' : null">
          <button class="btn btn-outline-primary"
                  [disabled]="apiService.inPinMode"
                  (click)="setPersonalDefaultCallback();activeModal.close();">
            Set Personal Default
          </button>
        </span>
      </div>
      <div>
        <span class="d-inline-block"
              [ngbTooltip]="isOrganizationAdmin ? null :
                'You must be an organization admin to set the organization default view.'">
          <button class="btn btn-outline-primary"
                  [disabled]="!isOrganizationAdmin"
                  (click)="setOrganizationDefaultCallback();activeModal.close();">
            Set Organization Default
          </button>
        </span>
      </div>
    </div>
  </div>

</ng-container>
